import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
}
const _hoisted_2 = {
  id: "menu",
  transform: "translate(0.5 0.5)"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconBurger',
  props: {
    classStroke: null,
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        id: "Path_9176",
        class: _normalizeClass([
          __props.classStroke,
          'svg-stroke',
        ]),
        "data-name": "Path 9176",
        d: "M4,6H20",
        transform: "translate(2)",
        fill: "none",
        stroke: "#ad1aac",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2),
      _createElementVNode("path", {
        id: "Path_9177",
        class: _normalizeClass([
          __props.classStroke,
          'svg-stroke',
        ]),
        "data-name": "Path 9177",
        d: "M4,12H20",
        fill: "none",
        stroke: "#ad1aac",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2),
      _createElementVNode("path", {
        id: "Path_9178",
        class: _normalizeClass([
          __props.classStroke,
          'svg-stroke',
        ]),
        "data-name": "Path 9178",
        d: "M4,18H20",
        transform: "translate(-2)",
        fill: "none",
        stroke: "#ad1aac",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 2)
    ])
  ]))
}
}

})